import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAlignCenter,
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faAnalytics,
  faAngleDown,
  faArrowCircleRight,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faLongArrowRight,
  faArrowUp,
  faArrowsV,
  faBold,
  faBookSpells,
  faBookmark,
  faBorderAll,
  faBrackets,
  faBullseye,
  faCaretCircleDown,
  faCheckCircle,
  faCheckSquare,
  faCircle,
  faClipboardListCheck,
  faClock,
  faCrown,
  faDollarSign,
  faCircleDollar,
  faDownload,
  faEquals,
  faEnvelope,
  faEdit,
  faEllipsisH,
  faEllipsisV,
  faExclamationCircle,
  faExclamationTriangle,
  faExpandAlt,
  faFile,
  faFileAlt,
  faFileCertificate,
  faFileContract,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileMedical,
  faFilePdf,
  faFileSpreadsheet,
  faFileWord,
  faFilesMedical,
  faFilter,
  faFlagAlt,
  faFont,
  faFolder,
  faFolderOpen,
  faFolders,
  faGlobe,
  faGripLines,
  faGripLinesVertical,
  faHandPointRight,
  faHdd,
  faHeartRate,
  faHome,
  faIndent,
  faInfoCircle,
  faItalic,
  faLink,
  faLinkSimple,
  faListOl,
  faListUl,
  faLock,
  faGripVertical,
  faMagic,
  faMicrophone,
  faMicroscope,
  faNetworkWired,
  faNote,
  faOutdent,
  faPaintBrush,
  faPaperPlane,
  faPen,
  faPercent,
  faPlayCircle,
  faPlus,
  faPlusCircle,
  faPuzzlePiece,
  faRightToBracket,
  faSearch,
  faSignature,
  faSort,
  faSpinner,
  faSquareM,
  faStars,
  faStickyNote,
  faStop,
  faStopwatch,
  faTags,
  faTasks,
  faText,
  faThumbsDown,
  faThumbsUp,
  faThumbtack,
  faTimesCircle,
  faTimesOctagon,
  faUnderline,
  faUnlink,
  faUser,
  faUserCircle,
  faUserFriends,
  faUserPlus,
  faUsers,
  faUsersCog,
  faUsersCrown,
  faVideo,
  faVideoPlus,
  faHashtag,
  faRobot,
  faUserCheck,
  faLineHeight,
  faHighlighter,
  faArrowsH,
  faSplit,
  faClipboardCheck,
} from "@fortawesome/pro-solid-svg-icons";

export default library.add(
  faAlignCenter,
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faAnalytics,
  faAngleDown,
  faArrowCircleRight,
  faArrowDown,
  faArrowLeft,
  faArrowUp,
  faArrowRight,
  faLongArrowRight,
  faArrowsV,
  faBold,
  faBookSpells,
  faBookmark,
  faBorderAll,
  faBrackets,
  faBullseye,
  faCaretCircleDown,
  faCheckCircle,
  faCheckSquare,
  faCircle,
  faClipboardListCheck,
  faClipboardCheck,
  faClock,
  faCrown,
  faDollarSign,
  faCircleDollar,
  faDownload,
  faEquals,
  faEnvelope,
  faEdit,
  faEllipsisH,
  faEllipsisV,
  faExclamationCircle,
  faExclamationTriangle,
  faExpandAlt,
  faFile,
  faFileAlt,
  faFileCertificate,
  faFileContract,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileMedical,
  faFilePdf,
  faFileSpreadsheet,
  faFileWord,
  faFilesMedical,
  faFilter,
  faFlagAlt,
  faFont,
  faFolder,
  faFolderOpen,
  faFolders,
  faGlobe,
  faGripLines,
  faGripLinesVertical,
  faHandPointRight,
  faHdd,
  faHeartRate,
  faHome,
  faIndent,
  faInfoCircle,
  faItalic,
  faLink,
  faLinkSimple,
  faListOl,
  faListUl,
  faLock,
  faGripVertical,
  faMagic,
  faMicrophone,
  faMicroscope,
  faNetworkWired,
  faOutdent,
  faPaintBrush,
  faPaperPlane,
  faPen,
  faPercent,
  faPlayCircle,
  faPlus,
  faPlusCircle,
  faPuzzlePiece,
  faRightToBracket,
  faSearch,
  faSignature,
  faSort,
  faSpinner,
  faSquareM,
  faStars,
  faStickyNote,
  faStop,
  faStopwatch,
  faTags,
  faTasks,
  faText,
  faThumbsDown,
  faThumbsUp,
  faThumbtack,
  faTimesCircle,
  faTimesOctagon,
  faUnderline,
  faUnlink,
  faUser,
  faUserCircle,
  faUserFriends,
  faUserPlus,
  faUsers,
  faUsersCog,
  faUsersCrown,
  faVideo,
  faVideoPlus,
  faHashtag,
  faRobot,
  faUserCheck,
  faLineHeight,
  faHighlighter,
  faArrowsH,
  faNote,
  faSplit,
);
